<script setup>
	import { computed } from 'vue';

	const props = defineProps({
		item: {
			type: Object,
			default: () => {},
		},
		itemsLength: {
			type: Number,
			default: 0,
		},
	});

	const formattedBusinessArea = computed(() => {
		if (props.item.BusinessAreaCategory?.includes(',')) {
			return props.item.BusinessAreaCategory.split(', ', 2);
		} else {
			return props.item.BusinessAreaCategory;
		}
	});
</script>

<template>
	<a
		:href="item.Url"
		:target="item.LinkTarget ? item.LinkTarget : ''"
		class="c-variable-width-card"
	>
		<div
			class="c-variable-width-card__image-wrapper"
			:class="{ 'c-variable-width-card__image-wrapper--four': itemsLength === 4 }"
		>
			<img
				v-if="item.ImageUrl && !item.HasDefaultImageUrl"
				:src="item.ImageUrl"
				:alt="item.Headline"
				class="c-variable-width-card__image"
			/>
			<div
				v-if="item.ImageUrl && item.HasDefaultImageUrl"
				class="c-variable-width-card__image--icon"
			>
				<img
					:src="item.ImageUrl"
					:alt="item.Headline"
				/>
			</div>
			<div
				v-if="!item.ImageUrl && item.HasDefaultImageUrl"
				class="c-variable-width-card__image"
			></div>
			<p
				v-if="item.NewBadgeText"
				class="c-variable-width-card__badge"
			>
				{{ item.NewBadgeText }}
			</p>
			<div
				v-if="item.MediaTypeIconUrl || item.Duration"
				class="c-variable-width-card__label"
			>
				<img
					v-if="item.MediaTypeIconUrl"
					:src="item.MediaTypeIconUrl"
					:alt="item.BusinessAreaCategory"
					class="c-variable-width-card__icon-media"
				/>
				<p
					v-if="item.Duration"
					class="c-variable-width-card__duration"
				>
					{{ item.Duration }}
				</p>
			</div>
		</div>
		<p
			v-if="Array.isArray(formattedBusinessArea)"
			class="c-variable-width-card__category"
		>
			<span
				v-for="businessAreaItem in formattedBusinessArea"
				:key="businessAreaItem"
			>
				{{ businessAreaItem }}
			</span>
		</p>
		<p
			v-else
			class="c-variable-width-card__category"
			v-text="formattedBusinessArea"
		></p>
		<h3 class="c-variable-width-card__heading" v-html="item.Headline"></h3>
	</a>
</template>
